import "../styles/home.css";
import TeamPanel from "../components/TeamPanel";

export default function Home() {
	return (
		<div className="page-container home-page">
			<img src="/css.png" alt="decorative" className="css-title" />
			<TeamPanel title="Our Team" folder="/about/team" />
			<fieldset className="home-section home-team-section">
				<legend className="section-heading-lg team">Our Team</legend>
				<p className="preline">
					Cretan Swing Shots is a self-managed dance group based in Heraklion, Crete. Founded in
					2013, we’re part of a broader community active within the University of Crete campus. Our
					group is driven by values of selflessness and co-creation, with organisation and decisions
					made collectively. We rely on donations from members and the public during the events we
					host, keeping everything community-centered.
				</p>
				<p>
					Honouring this dance's history means recognising both the joy and the struggle woven into the
					movement, and resisting the way commercial culture often strips such art forms of their
					roots. We work outside the logic of profit, built on shared effort, mutual learning, and
					open participation. An organising team helps keep things moving and we hold regular
					assemblies, where decisions are made collectively and everyone has a voice.
				</p>
				<p>
					For us, dance isn’t just performance; it’s a way to connect, to learn, and to push back
					against the idea that culture is something you buy rather than build together. In our
					small corner of the world, we’re keeping a space open for creativity that belongs to
					everyone willing to share in it.
				</p>
			</fieldset>
			{/* Feature photo from public/about */}
			<img
				className="home-feature-photo"
				src="/about/home_fk_photo.jpg"
				alt="Cretan Swing Shots - team photo"
			/>
			<fieldset className="home-section home-space-section">
				<legend className="section-heading-lg space">Our Space</legend>
				<p className="preline">
					Our home is the Students' Centre, where students, graduates, and local residents come
					together to teach, learn, host seminars, and organise social dances.
				</p>
				<p>
					The Students’ Centre is located at the foot of the University of Crete’s Voutes campus.
					This open, public space welcomes not only university students and staff but also the
					broader local community. The building was once abandoned and underused, but over time, it
					has been revitalized with new energy, thanks to collective efforts.
				</p>
			</fieldset>
		</div>
	);
}
